<template lang="pug">
  .column
    .column(v-if='ownList')
      .resources
        resource-card.m-bottom-2(
          v-for='resource in myResources.resources'
          :key='resource.id'
          :resource='resource'
          isKrea
          noMargin
        )
      .column.center(v-if='!myResources.resources.length')
        h2.title-medium.m-bottom-2.gray {{ $t('krea.resources.emptyResourcesTitle') }}
        p.text-normal.m-bottom-2.gray {{ $t('krea.resources.emptyResourcesDesc') }}
        router-link(:to='{name: routes.kreaNewResource}')
          button.primary-button {{ $t('krea.resources.newResource') }}
    .resources(v-else)
      resource-card.m-bottom-2(
        v-for='resource in schoolsGroupResources.resources'
        :key='resource.id'
        :resource='resource'
        isKrea
        noMargin
      )
    h2.pointer.m-top-1.text-center.text-normal.blue(
      v-if='existsMore'
      @click='loadMore'
    ) {{ $t('krea.resources.showMore') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ResourceCard from '@/components/ResourceCard'
import { routes } from '../../../router'

export default {
  components: { ResourceCard },
  props: {
    ownList: { type: Boolean, default: false }
  },
  data() {
    return {
      routes,
      pageNumber: 0
    }
  },
  computed: {
    ...mapState({
      myResources: state => state.kreaResources.myResources,
      schoolsGroupResources: state => state.kreaResources.schoolsGroupResources,
      siteLanguage: state => state.behavior.locale,
      userInfo: state => state.userInfo.userInfo
    }),
    existsMore() {
      return this.ownList
        ? this.myResources.resources.length < this.myResources.totalCount
        : this.schoolsGroupResources.resources.length < this.schoolsGroupResources.totalCount
    }
  },
  watch: {
    siteLanguage() {
      this.clearKreaResources()
      this.pageNumber = 0
      this.getResources()
    },
    ownList() {
      this.clearKreaResources()
      this.pageNumber = 0
      this.getResources()
    }
  },
  created() {
    this.getResources()
  },
  methods: {
    ...mapActions([
      'hydrateKreaMyResources',
      'hydrateKreaSchoolsGroupResources',
      'showElement',
      'hideElement',
      'clearKreaResources'
    ]),
    async loadMore() {
      if (this.ownList) {
        this.pageNumber = this.pageNumber + 1
        this.showElement({ element: 'fullPageLoader' })
        await this.hydrateKreaMyResources({ pageNumber: this.pageNumber })
        this.hideElement({ element: 'fullPageLoader' })
      } else {
        this.pageNumber = this.pageNumber + 1
        this.showElement({ element: 'fullPageLoader' })
        await this.hydrateKreaSchoolsGroupResources({ pageNumber: this.pageNumber })
        this.hideElement({ element: 'fullPageLoader' })
      }
    },
    async getResources() {
      this.showElement({ element: 'fullPageLoader' })
      if (this.ownList) await this.hydrateKreaMyResources()
      else await this.hydrateKreaSchoolsGroupResources()
      this.hideElement({ element: 'fullPageLoader' })
    }
  },
  beforeDestroy() {
    this.clearKreaResources()
  }
}
</script>

<style lang="scss" scoped>
.resources{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 280px);
  gap: 5px;
  justify-content: space-between;
}
.pointer{
  cursor: pointer;
}
</style>
